import { ComponentType } from "groopit-js";
import IMask from "imask";
import React, { useEffect } from "react";

interface DecimanDataEditorProps {
  description: string;
  parentComponent?: ComponentType;
  disabled: boolean;
  baseName: string;
  places: number;
  format: string;
  number?: number;
}

export const DecimalDataEditor = (props: DecimanDataEditorProps) => {
  const {
    description,
    parentComponent,
    disabled,
    baseName,
    places,
    format,
    number,
  } = {
    ...props,
  };

  const [inputElement, setInputElement] =
    React.useState<HTMLInputElement | null>(null);

  useEffect(() => {
    if (inputElement) {
      IMask(inputElement, {
        mask: Number, // enable number mask

        // other options are optional with defaults below
        scale: places, // digits after point, 0 for integers
        signed: true, // allow negative
        thousandsSeparator:
          format[0] === "N" || format[0] === "C" || format[0] === "P"
            ? ","
            : "", // any single char
        padFractionalZeros: false, // if true, then pads zeros at end to the length of scale
        normalizeZeros: false, // appends or removes zeros at ends
        radix: ".", // fractional delimiter
        mapToRadix: ["."], // symbols to process as radix

        // additional number interval options (e.g.)
        min: -999999999,
        max: 999999999,
      });
    }
  }, [inputElement, format, places]);

  return (
    <>
      <input type="hidden" name={`${baseName}.Places`} value={places} />
      <input type="hidden" name={`${baseName}.Format`} value={format} />
      <input
        type="hidden"
        name={`${baseName}.IsPercent`}
        value={format[0] == "P" ? "true" : "false"}
      />
      {parentComponent == ComponentType.Table ? (
        <div className="number-editor h-full">
          <input
            title={description}
            ref={(element) => setInputElement(element)}
            name={`${baseName}.Number`}
            type="text"
            className="inline-block"
            disabled={disabled}
            defaultValue={number}
          />
        </div>
      ) : (
        <>
          <div className="flex space-x-3 post-component">
            <img
              alt="Number Icon"
              src="/Content/Images/ic_number.png"
              className="groopit-component-icon-sm"
            />
            <div className="flex-grow number-editor space-x-2">
              <input
                ref={(element) => setInputElement(element)}
                id={`${baseName}.Number`}
                name={`${baseName}.Number`}
                type="text"
                className="form-control inline-block w-1/3 mt-0"
                disabled={disabled}
                defaultValue={number}
              />
              <label
                htmlFor={`${baseName}.Number`}
                className="text-display-normal text-color-secondary"
              >
                {description}
              </label>
            </div>
          </div>
        </>
      )}
    </>
  );
};
